module.exports = __webpack_public_path__ + "img/filter_icon_gray.ed769da5.svg";